import Toastr from "../../../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  saving: false,
  graph_data: {},
  kpi_data: {},
  rpa_vision_insurance_logs: [],
}

let changes = null
export const visionInsuranceReportReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'VISION_INSURANCE_DASHBOARD_LOAD_PENDING':
      return { ...state, saving: true };

    case 'VISION_INSURANCE_CLAIM_SUBMIT_LOGS_LOAD_PENDING':
      return { ...state, saving: true, rpa_vision_insurance_logs: [] };

    case 'VISION_INSURANCE_DASHBOARD_LOAD_REJECTED':
    case 'VISION_INSURANCE_CLAIM_SUBMIT_LOGS_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_DASHBOARD_LOAD_FULFILLED':
      changes = { [`${response.meta.params}_data`]: { ...response.records }, meta: { ...response.meta }, saving: false }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_CLAIM_SUBMIT_LOGS_LOAD_FULFILLED':
      changes = { ...response, saving: false }
      return { ...state, ...changes };

    default:
      return state
  }
}